import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import TextCell from "./core/TextCell.js";

const UsernameAdminCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const editableUser = !!(props as any).handleUsernameClicked;

  return (
    <TableCell
      triggerButtonProps={
        editableUser
          ? {
              onPress: () => (props as any).handleUsernameClicked(props.data.user),
              label: "Edit User",
              icon: "edit",
              e2eActionId: "edit-user",
            }
          : undefined
      }
    >
      <TextCell {...props} tooltip={props.value} />
    </TableCell>
  );
};

export { UsernameAdminCell };
export default UsernameAdminCell;
